import { useQuery } from '@tanstack/react-query';
import { getAgency } from '../../api/apiAgencies';

export const useGetAgency = (id) => {
    return useQuery({
        queryKey: ['agency', id],
        queryFn: () => getAgency(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
